import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreTextField } from 'src/components/core'
import { useSelector, useDispatch } from 'react-redux'
import { useState, useEffect } from 'react'
import CustomizedSwitch from 'src/components/customized-switch'
import { PatchContent, PatchData } from 'src/model/patch'
import { patchCollectionSettingsAction } from 'src/reducers/collection/action'
import { patchCourseCollectionAction } from 'src/reducers/collection/action'
import { getCollectionSettingsAction } from 'src/reducers/collection/action'
const GeneralSettings = props => {
  const { classes } = props
  const collection = useSelector(state => state.collection.collection)
  const collectionSettings = useSelector(
    state => state.collection.collectionSettings,
  )
  const dispatch = useDispatch()
  const [collectionTitle, setCollectionTitle] = useState(collection.name)

  useEffect(() => {
    if (collectionSettings == null) {
      dispatch(getCollectionSettingsAction(collection.id, response => {}))
    }
  }, [])

  useEffect(() => {
    setCollectionTitle(collection.name)
  }, [collection])

  const [isSequential, setIsSequential] = React.useState(
    collectionSettings.isSequential == null
      ? false
      : collectionSettings.isSequential,
  )

  useEffect(() => {
    setIsSequential(collectionSettings.isSequential)
  }, [collectionSettings])

  const handleSequentialSwitch = () => {
    setIsSequential(!isSequential)

    const patchSource = new PatchData(null, collection.id)
    patchSource.addContent(
      new PatchContent(
        !isSequential,
        'isSequential',
        PatchData.OPERATION_REPLACE,
      ),
    )
    dispatch(patchCollectionSettingsAction(patchSource, () => {}))
  }

  const handleTitleChange = e => {
    const patchSource = new PatchData(null, collection.id)
    patchSource.addContent(
      new PatchContent(
        e.target.value,
        'collectionName',
        PatchData.OPERATION_REPLACE,
      ),
    )
    dispatch(patchCourseCollectionAction(patchSource))
  }

  return (
    <div className={classes.root}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography className={classes.header}>General Settings</Typography>
        <Typography className={classes.description}>
          Customize settings for your collection to meet specific requirements
          and optimize the learner experience.
        </Typography>
      </div>

      <CoreTextField
        label="Collection Title"
        value={collectionTitle}
        onChange={e => setCollectionTitle(e.target.value)}
        onBlur={e => handleTitleChange(e)}
      />
      <div className={classes.row}>
        <CustomizedSwitch
          onClick={() => handleSequentialSwitch()}
          checked={isSequential}
        ></CustomizedSwitch>
        <div className={classes.textContainer}>
          <Typography fontSize="14px" fontWeight={500}>
            Proceed in Order
          </Typography>
          <Typography fontSize="14px" fontWeight={400} color="#838D98">
            Learners can proceed to next mini-course only after completing the
            previous one.
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(GeneralSettings)
